import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { SessionService } from '@app/core/session/session.service';
import { LoginService } from '@app/+login/login.service';
import storage from 'local-storage-fallback';
import { V2LoginConfirmationAbstract } from '@app/+login/deprecated-hybrid/views/magic-link-login-confirmation/v2-login-confirmation.abstract.component';
import { LetDirective } from '@ngrx/component';
import { MissingIdentifierInfoComponent } from '@app/+login/deprecated-hybrid/components/missing-identifier-info/missing-identifier-info.component';
import { TranslatePipe } from '@ngx-translate/core';
import { LOGIN_ID_STORAGE_ITEM_KEY } from '@app/+login/deprecated-hybrid/consts';

@Component({
  templateUrl: './magic-link-login-confirmation.component.html',
  imports: [
    LetDirective,
    MissingIdentifierInfoComponent,
    TranslatePipe,
  ],
})
export class MagicLinkLoginConfirmationComponent extends V2LoginConfirmationAbstract implements OnInit {
  public readonly otp$ = this.route.queryParamMap.pipe(
    map(params => params.get('otp')),
  );

  constructor(cdr: ChangeDetectorRef,
              router: Router,
              route: ActivatedRoute,
              loginService: LoginService,
              private sessionService: SessionService) {
    super(loginService, cdr, router, route);
  }

  public ngOnInit(): void {
    this.signIn().subscribe(
      () => this.onSuccess(),
      () => this.onError(),
    );
  }

  private signIn(): Observable<unknown> {
    return this.otp$.pipe(
      map(otp => ({
        otp: otp as string,
        identifier: JSON.parse(storage.getItem(LOGIN_ID_STORAGE_ITEM_KEY) as string),
      })),
      filter(({ otp, identifier }) => !!otp && identifier),
      switchMap(({ otp, identifier }) => this.sessionService.deprecatedSignIn(
        JSON.parse(storage.getItem(LOGIN_ID_STORAGE_ITEM_KEY) as string),
        otp,
        this.sessionService.getOtpSecret(),
      )),
    );
  }
}
